import { useRootContext } from './partials/context/rootContext';

//console.log("root context", window.pageVars);

var styles = {};

if(window.pageVars){
    const wpStyles = window.pageVars.theme;

    // Text Colors
    const textColor1 = { color: wpStyles.color_1 }
    const textColor2 = { color: wpStyles.color_2 };
    const textColor3 = { color: wpStyles.color_3 };
    const textColor4 = { color: wpStyles.color_4 };
    
    // Background Colors
    const backgroundColor1 = { backgroundColor: wpStyles.color_1 }
    const backgroundColor2 = { backgroundColor: wpStyles.color_2 }
    const backgroundColor3 = { backgroundColor: wpStyles.color_3 }
    const backgroundColor4 = { backgroundColor: wpStyles.color_4 }
    
    // Hover Background Colors
    const backgroundHoverColor1 = { backgroundColor: wpStyles.color_1 }
    const backgroundHoverColor2 = { backgroundColor: wpStyles.color_2 }
    const backgroundHoverColor3 = { backgroundColor: wpStyles.color_3 }
    const backgroundHoverColor4 = { backgroundColor: wpStyles.color_4 }
    
    
    //Export
    styles = {
        color1: wpStyles.color_1,
        color2: wpStyles.color_2,
        color3: wpStyles.color_3,
        color4: wpStyles.color_4, 
    
        textColor1: textColor1,
        textColor2: textColor2,
        textColor3: textColor3,
        textColor4: textColor4,
    
        backgroundColor1: backgroundColor1,
        backgroundColor2: backgroundColor2,
        backgroundColor3: backgroundColor3,
        backgroundColor4: backgroundColor4,
    
    
    }
}

export default styles;
